import pt from "./messages/pt";
import es from "./messages/es";
import fr from "./messages/fr";
import de from "./messages/de";
import ar from "./messages/ar";
import br from "./messages/br";
import it from "./messages/it";
import { MARKETS, MARKET_DICTS, MARKET_CODES } from "./markets";

// Locale dictionaries. English is the master: components carry the approved
// English copy as fallback defaults, and dictionaries override per locale.
// Missing keys in any locale fall back to English automatically.
const DICTS = { pt, es, fr, de, ar, br, it };

export { MARKETS, MARKET_CODES };

// OYG family locales (unchanged). PT Studio family adds Italian (it) —
// PT_LOCALES drives the PT routes, selector and hreflang set only.
export const LOCALES = ["en", "pt", "es", "fr", "de", "ar", "br"];
export const PT_LOCALES = ["en", "pt", "br", "es", "fr", "de", "it", "ar"];
export const RTL_LOCALES = ["ar"];
export const DEFAULT_LOCALE = "en";

export const PROD_BASE = "https://yanrefitness.eu";

export const lpPath = (locale) =>
  locale === DEFAULT_LOCALE ? "/open-your-gym" : `/${locale}/open-your-gym`;

export const ptsPath = (locale) =>
  locale === DEFAULT_LOCALE ? "/personal-trainer-studio" : `/${locale}/personal-trainer-studio`;

// BCP-47 language tag per locale — route key "br" maps to pt-BR for
// <html lang> and hreflang. All other locales use their code as-is.
// Country markets (Africa Wave 1) map to language-COUNTRY (en-ZA, fr-MA…),
// reflecting the ACTIVE interface language (Mauritius can switch EN⇄FR).
export const localeTag = (locale, lang) => {
  const market = MARKETS[locale];
  if (market) return `${lang || market.lang}-${locale.toUpperCase()}`;
  return locale === "br" ? "pt-BR" : locale;
};

// Hreflang tags for the PT Studio family: pt is explicitly pt-PT there.
export const ptsLocaleTag = (locale) =>
  locale === "br" ? "pt-BR" : locale === "pt" ? "pt-PT" : locale;

// OYG hreflang cluster: language locales + Africa Wave 1 country markets.
export const OYG_SEO_LOCALES = [...LOCALES, ...MARKET_CODES];

// Translation lookup. Country markets resolve: market overrides (country-
// specific metadata/positioning) → active language dictionary → fallback.
// `lang` is the market's ACTIVE interface language (default = primary).
// When the visitor switches to a secondary language in place (Mauritius
// EN→FR), the language dictionary wins so no primary-language copy leaks.
export const t = (locale, key, fallback, lang) => {
  const market = MARKETS[locale];
  if (market) {
    const active = lang || market.lang;
    if (active !== market.lang) {
      return DICTS[active]?.[key] ?? MARKET_DICTS[locale]?.[key] ?? fallback ?? key;
    }
    return MARKET_DICTS[locale]?.[key] ?? DICTS[active]?.[key] ?? fallback ?? key;
  }
  return DICTS[locale]?.[key] ?? fallback ?? key;
};
